module.exports = __webpack_public_path__ + "static/media/hi.6ab9d83c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/hi.svg
// module id = 32
// module chunks = 0